export default __webpack_public_path__ + "static/media/AboutUs_BG-02.bb29913f.png";